module.exports = "<form class=\"kl-form f-row f-cb {class}\" r-class=\"{{'kl-form--inline':!!inline}}\">\n    {#if this.controls && this.controls.length === 1}\n    <input style=\"display: none;\" />\n    {/if}\n\t{#inc this.$body}\n</form>\n"


//////////////////
// WEBPACK FOOTER
// ../src/js/components/form/common/KLForm/index.html
// module id = 390
// module chunks = 0